import firebase from "./firebase";
import axios from "axios";

export const updateBookingStatusService = async ({ id, bookingStatus }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.patch(
    `${process.env.REACT_APP_UPDATE_BOOKING_STATUS}`,
    { id, bookingStatus },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const approveAppointmentRequestService = async ({ id, appointment }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_APPROVE_APPOINTMENT}`,
    {
      id,
      appointment,
      selectedSMSTemplateSetId: appointment.selectedSMSTemplateSetId,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const updateAppointmentInPMS = async ({ caId, appointmentStatus }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.patch(
    `${process.env.REACT_APP_UPDATE_APPOINTMENT}`,
    { id: caId, appointment: { appointmentStatus } },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};
